// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1_hpt","info":"UpdateTermsInfo_info__1RekN"};